import { useTrack } from "@hackler/react-sdk"
import useLoginPopup from "../../hooks/useLoginPopup"
import * as React from "react"
import { useEffect } from "react"
import SDKIntegration from "../../components/SDKIntegration"
import About from "../Home/components/About"
import { Button } from "@material-ui/core"
import { GAEvent } from "../../modules/GoogleAnalytics"
import { FormattedMessage } from "react-intl"
import Footer from "../Home/components/Footer"
import MainVisual from "./components/MainVisual"
import DataInsight from "./components/DataInsight"
import Retention from "./components/Retention"
import Summary from "./components/Summary"
import EventManagement from "./components/EventManagement"

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL
export default function Analytics() {
  const track = useTrack()
  const loginPopup = useLoginPopup()

  useEffect(() => {
    track({ key: "homepage_data_analytics_view" })
  }, [])

  return (
    <>
      <MainVisual />
      <DataInsight />
      <Retention />
      <Summary />
      <EventManagement />
      <SDKIntegration />
      <About
        pageName="analytics"
        serviceButtonComponent={({ isMobile, className }) => (
          <Button
            color={"inherit"}
            variant={"contained"}
            fullWidth={isMobile}
            className={className}
            onClick={() => {
              GAEvent({
                category: "analytics-7",
                action: "click",
                label: "start analytics",
              })
              track({ key: "homepage_all_data_analytics_start_click" })
              track({ key: "homepage_analytics_about_analytics_start_click" })
              loginPopup(`${dashboardUrl}/analytics`)
            }}>
            <strong>
              <FormattedMessage id={"CTA_ANALYTICS"} />
            </strong>
          </Button>
        )}
      />
      <Footer pageName={"analytics"} />
    </>
  )
}
